module.exports = __webpack_public_path__ + "img/astral_12.c6f19dd0.svg";